import React from "react"
import { FormattedMessage } from "react-intl"
import { Link } from "gatsby"
import { useIntl } from "react-intl"
import { langId } from "../languages"
import { useLinkLanguage } from "../hooks"

const langLinkConfigArr = [
  {
    lang: "zh-HK",
    title: "繁體",
    text: "繁",
  },
  {
    lang: "zh-CN",
    title: "簡體",
    text: "簡",
  },
  {
    lang: "en",
    title: "English",
    text: "ENG",
  },
]

const Header = ({ baseSlug }) => {
  const intl = useIntl()
  const linkLanguage = useLinkLanguage()
  const currenetLocal = intl.locale
  return (
    <div className="header">
      <Link to={`/${currenetLocal}/`} className="header__title">
        <FormattedMessage id={langId.HEADER_TITLE}></FormattedMessage>
      </Link>
      <div className="header__lang">
        {langLinkConfigArr
          .filter(langlink => langlink.lang !== currenetLocal)
          .map(langlink => (
            <Link
              key={langlink.lang}
              to={`/${langlink.lang}/${baseSlug ? baseSlug + "/" : ""}`}
              lang={langlink.lang}
              title={langlink.title}
            >
              {langlink.text}
            </Link>
          ))}
      </div>

      <a
        className="header__link"
        href={`https://www.linkreit.com/${linkLanguage}/media/publication/?pageType=channel823`}
        rel="noopener"
        target="_blank"
        title={intl.formatMessage({ id: langId.LINK_REIT })}
      >
        {`${intl.formatMessage({ id: langId.PREVIOUS_ISSUES })}>>`}
      </a>
    </div>
  )
}

export default Header
